export const RECORDING_OPTIONS_COOKIE = 'pmwre';
